import * as React from 'react';

import { cn } from 'utils/shadcn';

import tqlLogo from '../assets/branding/tql-logo.svg';

type TQLLogoProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  compact?: boolean;
};

/** Total Quality Logistics wordmark (shared with drumkit-portal). */
export function TQLLogo({
  className,
  compact,
  alt = 'Total Quality Logistics',
  ...props
}: TQLLogoProps) {
  return (
    <img
      src={tqlLogo}
      alt={alt}
      className={cn(
        'w-auto shrink-0 object-contain',
        compact ? 'h-5 max-w-[72px]' : 'h-7 max-w-[100px]',
        className
      )}
      {...props}
    />
  );
}
